// src/reducers/productHandlerReducer.js
import { types } from '../types/types';

const initialEditingItem = Object.freeze({
    id: 0,
    productFk: 0,
    productName: '',        // útil cuando abras para editar mostrando nombre
    measurementUnit: '',    // ej: 'gls' | 'lts' | 'und'
    manager: 0,             // 0 = Cantidad, 1 = Monto
    countOrAmount: 0,       // valor numérico
    realmFk: '',            // se llenará al guardar con el realm del usuario
    status: true,
    availableProductHandlers: [],
    editProductHandlerGroupInfo : {},
});

const initialState = {
    editingItem: initialEditingItem,
};

export const productHandlerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingProductHandlerInfo:
            return {
                ...state,
                // merge para conservar claves por si payload viene parcial
                editingItem: { ...initialEditingItem, ...action.payload },
            };

            case types.setAvailableProductHandlers:
            return {
                ...state,
                availableProductHandlers: action.payload
            };
             case types.setEditingProductHandlerGroupInfo:
            return {
                ...state,
                editProductHandlerGroupInfo: action.payload
            };
        case types.clearProductHandlerInfo:
            return {
                ...state,
                editingItem: initialEditingItem,
            };

        default:
            return state;
    }
};